// @core/api/endpoints/billing/void_journal_entry.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  VoidJournalEntryRequest,
  VoidJournalEntryResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Void journal entry (creates reversing entry)
 * Voids a posted journal entry by creating an automatic reversing entry. The original entry is marked as voided and account balances are corrected.
 */
export async function VoidJournalEntry(
  id: string,
  data: VoidJournalEntryRequest,
  options?: RequestOptions
): Promise<VoidJournalEntryResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/journal-entries/:id/void`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<VoidJournalEntryResponse>(requestPath, data, requestOptions);
}
